import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getUserData() {
  try {
    yield put(actions.setUserAction(true));
    const result = yield call(api.getUserData);
    yield put(actions.getUserDataSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
  } finally {
    yield put(actions.setUserAction(false));
  }
}

function* getNotification({ payload }) {
  console.log(payload);
  try {
    yield put(actions.setUserAction(true));
    const result = yield call(api.getNotifications, payload);
    yield put(actions.getNotificationsSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
  } finally {
    yield put(actions.getNotificationsFail(false));
  }
}

function* getGovernorates() {
  try {
    yield put(actions.setUserAction(true));
    const result = yield call(api.getGovernorates);
    yield put(actions.getGovernoratesSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
  } finally {
    yield put(actions.setUserAction(false));
  }
}

function* getMajors() {
  try {
    yield put(actions.setUserAction(true));
    const result = yield call(api.getMajors);
    yield put(actions.getMajorsSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
  } finally {
    yield put(actions.setUserAction(false));
  }
}

function* getGrades() {
  try {
    yield put(actions.setUserAction(true));
    const result = yield call(api.getGrades);
    yield put(actions.getGradesSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
  } finally {
    yield put(actions.setUserAction(false));
  }
}

function* getUserGroups({ payload }) {
  try {
    yield put(actions.setUserAction(true));
    const result = yield call(api.getUserGroups, payload);
    yield put(actions.getUserGroupsSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
  } finally {
    yield put(actions.setUserAction(false));
  }
}

export default function* userSaga() {
  yield takeLatest(Types.GET_GOVERNORATES_REQUEST, getGovernorates);
  yield takeLatest(Types.GET_MAJORS_REQUEST, getMajors);
  yield takeLatest(Types.GET_GRADES_REQUEST, getGrades);
  yield takeLatest(Types.GET_USER_DATA_REQUEST, getUserData);
  yield takeLatest(Types.GET_NOTIFICATIONS_REQUEST, getNotification);
  yield takeLatest(Types.GET_USER_GROUPS_REQUEST, getUserGroups);
}
